import { PiRepeat, PiRowsPlusTop, PiUsers } from "react-icons/pi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineEdit } from "react-icons/md";
import { IoLink, IoReload } from "react-icons/io5";
import { Space } from "antd";
import { PiEyedropperLight } from "react-icons/pi";
import { CustomDot } from "./components/Charts/CustomBadge";
import { FaRegUser } from "react-icons/fa";

export const isDevMode = process.env.REACT_APP_ENV === "development";
export const APP_VERSION = "1.0.2";

export const roleIds = {
  Admin: 1,
  Customer: 2,
  SalesPerson: 3,
  SalesManager: 4,
};

export const roleNames = {
  1: "Admin",
  2: "Customer",
  3: "Salesperson",
  4: "Sales Manager",
};

export const routePrefix = {
  customer: "",
  admin: "/admin",
  sales: "/sales",
};

export const items = [
  {
    label: "1st menu item",
    key: "1",
    // icon: <UserOutlined />,
  },
  {
    label: "2nd menu item",
    key: "2",
    // icon: <UserOutlined />,
  },
  {
    label: "3rd menu item",
    key: "3",
    // icon: <UserOutlined />,
    danger: true,
  },
  {
    label: "4rd menu item",
    key: "4",
    // icon: <UserOutlined />,
    danger: true,
    disabled: true,
  },
];

export const actionMenuItems = [
  {
    key: "1",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <PiRepeat />
        </div>
        Re-assign Clients
      </Space>
    ),
  },
  {
    key: "4",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <FaRegUser />
        </div>
        Manage Agents
      </Space>
    ),
  },
  {
    key: "2",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <MdOutlineEdit />
        </div>
        Update Edit Access
      </Space>
    ),
  },
  {
    key: "3",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <RiDeleteBin6Line />
        </div>
        Delete
      </Space>
    ),
  },
];

export const getClientMenuItems = (record) => [
  {
    key: "1",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <PiRepeat />
        </div>
        Re-assign Salesperson
      </Space>
    ),
  },
  {
    key: "2",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <MdOutlineEdit />
        </div>
        {record?.is_edit_allowed ? "Remove Edit Access" : "Allow Edit Access"}
      </Space>
    ),
  },
  {
    key: "3",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <RiDeleteBin6Line />
        </div>
        Delete
      </Space>
    ),
  },
];

export const productsMenuItems = [
  // {
  //   key: "editImage",
  //   label: (
  //     <Space className="text-[#A33434] font-semibold">
  //       <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
  //         <MdOutlineEdit />
  //       </div>
  //       Edit Image
  //     </Space>
  //   ),
  // },
  {
    key: "removeFromNewlyAdded",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="p-1.5 rounded-full border">
          <CustomDot color={"#A33434"} size={10} />
        </div>
        Remove from Now Trending
      </Space>
    ),
  },
  {
    key: "addToNewlyAdded",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="p-1.5 rounded-full border">
          <CustomDot color={"darkgray"} size={10} />
        </div>
        Add to Now Trending
      </Space>
    ),
  },
  {
    key: "addToBestSelling",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="p-1.5 rounded-full border">
          <CustomDot color={"darkgray"} size={10} />
        </div>
        Add to Top Selling
      </Space>
    ),
  },
  {
    key: "removeFromBestSelling",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="p-1.5 rounded-full border">
          <CustomDot color={"#A33434"} size={10} />
        </div>
        Remove from Top Selling
      </Space>
    ),
  },
  {
    key: "updateShades",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <PiEyedropperLight />
        </div>
        View Shades
      </Space>
    ),
  },
  {
    key: "updateStock",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <PiRowsPlusTop />
        </div>
        Update Stock
      </Space>
    ),
  },
  {
    key: "linkProducts",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <IoLink />
        </div>
        Link Product
      </Space>
    ),
  },
];

export const orderDetailProductsMenuItems = [
  {
    key: "1",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <IoReload />
        </div>
        Reorder
      </Space>
    ),
  },
  {
    key: "2",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <MdOutlineEdit />
        </div>
        Edit
      </Space>
    ),
  },
  {
    key: "3",
    label: (
      <Space className="text-[#A33434] font-semibold">
        <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
          <RiDeleteBin6Line />
        </div>
        Delete
      </Space>
    ),
  },
];

export const statesList = [
  // States
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

export const variableType = {
  codeName: "code",
  passwordName: "password",
};

export const options = [
  {
    value: "+91",
    label: "+91",
  },
];

export const deleteDefaultAddressMsg = (type = "") => `Must have one default ${type && type + " "}address`;

export const formRules = {
  required: [{ required: true, message: "Please enter above field." }],
  phone: [
    { required: true, message: "Please enter above field." },
    {
      pattern: /^[0-9]{10}$/,
      message: "Please enter a valid 10-digit phone number.",
    },
  ],
  email: [
    { required: true, message: "Please enter above field." },
    {
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
      message: "Please enter a valid email address.",
    },
  ],
  password: [
    { required: true, message: "Please enter above field." },
    { min: 8, message: "Password must be 8-20 characters." },
    { max: 20, message: "Password must be 8-20 characters." },
    {
      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/,
      message: "Password must contain at least one uppercase letter, one lowercase letter, one number and one special character.",
    },
  ],
  confirmPass: (key = "password") => [
    { required: true, message: "Please confirm password." },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue(key) === value) {
          return Promise.resolve();
        }
        return Promise.reject(new Error("Passwords do not match!"));
      },
    }),
  ],
  postalCode: [
    { required: true, message: "Please enter above field." },
    { pattern: /^[0-9]+$/, message: "Postal code must be a number." },
    { len: 6, message: "Postal code must be exactly 6 digits." },
  ],
  partyCode: [
    { required: true, message: "Please enter above field." },
    { pattern: /^[0-9]+$/, message: "Party code must be a number." },
  ],
};

export const orderStatus = {
  placed: "Order Placed",
  production: "In Production",
  dispatched: "Dispatched",
  parts_dispatched: "Part Dispatched",
  cancelled: "Cancelled",
  parts_cancelled: "Part Cancelled",
};

export const sampleClient = {
  company_name: "Alice",
  contact_person: "new client",
  email: "alice.smith@example.com",
  phone: "9876543210",

  display_email_address: "alice.smith@example.com",
  display_contact_no: "9876543210",
  designation: "Manager",
  zone: "North Zone",
  area: "Area 51",
  id_type: "Passport",
  id_no: "A1234567",
  agent_remark: "New employee",
  party_code: "123456",
  agent_name: "new agent",

  address_line1: "100 Business Park",
  address_line2: "Suite 200",
  city: "Metropolis",
  post_code: "12345",
  profile_url: "",
};

export const sampleSales = {
  full_name: "Alice",
  email: "alice.smith@example.com",
  phone: "9876543210",

  display_email_address: "alice.smith@example.com",
  display_contact_no: "9876543210",
  designation: "Manager",
  zone: "North Zone",
  area: "Area 51",
  id_type: "Passport",
  id_number: "A1234567",
  remark: "New employee",

  office_address_line_1: "100 Business Park",
  office_address_line_2: "Suite 200",
  office_city: "Metropolis",
  office_postal_code: "12345",
  office_address_type: "office",

  residential_address_line_1: "42 Maple Street",
  residential_address_line_2: "Apt 5",
  residential_city: "Smalltown",
  residential_postal_code: "67890",
  residential_address_type: "residential",
};

export const modificationTitlesTags = {
  updateTitle: "Update Client Request",
  updateTags: (full_name, comp_name) => `Client update request by ${full_name} for client ${comp_name}`,
  pendingTitle: "Pending Client Request",
  pendingTags: (comp_name) => `New client registered ${comp_name}`,
};

export const showDevLogs = process.env.REACT_APP_SHOW_DEV_LOGS === "true";

export const idTypeEnums = {
  client: ["GSTIN", "PAN", "CIN"],
  user: ["Aadhaar", "PAN", "Passport"],
};

export const scrollToTop = (scrollBehavior = "smooth") => {
  const container = document.querySelector(".scrollable-content");
  if (!container) return;
  container.scrollTo({ top: 0, behavior: scrollBehavior });
};

export const timeLimitForOtp = 60; // in seconds

export const resendOtpMessage = (timer) => `Resend OTP in ${timer} Sec`;

export const perPageOptions = ["10", "20", "50", "100"];

export const disclaimerItems = [
  "Images shown may vary from actual products and shades due to effects of photography, lighting, device-display specifications, or allowed minor shade variations.",
  // "Prices displayed are only indicative, and may vary as per shade selection, custom specifications, seasonality, or other factors.",
  "“In Stock” indication is only an estimate. Actual stock availability may vary depending on real-time updates.",
  "Quantities are only estimates. Actual meters in each case may vary at the time of dispatch.",
  "Dispatch times are only estimates and may vary.",
];

export const estimatedDispatchTimes = {
  in_stock: "2-3 days.",
  grey: "10-15 days.",
  make_to_order_pd: "30-40 days.",
  make_to_order_td: "45-60 days.",
  generic: "30-60 days.",
};

export const DYED_TYPES = {
  piece: "PIECE DYED",
  pieceLabel: "Piece Dyed",
  top: "TOP DYED",
  topLabel: "Top Dyed",
};

export const shirtingCompCodes = [9013, "9013"];

export const PERMISSION_IDS = {
  UNIVERSAL_ORDER_MANAGEMENT: 1,
  UNIVERSAL_BOOKING_STOCKS: 2,
  IMAGE_EDITING: 3,
  PRODUCT_MANAGEMENT: 4,
  BROCHURE_MANAGEMENT: 5,
  SCHEME_MANAGEMENT: 6,
  VIEW_ALL_CLIENTS: 7,
  VIEW_ALL_SALESPERSONS: 8,
  VIEW_ALL_OUTSTANDING: 9,
};

export const SELECTED_CUSTOMER_STORAGE_KEY = "customerSelection:orders";
